module.exports = __webpack_public_path__ + "img/green-check.1892469a.svg";